import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Cloudinary } from 'services/cloudinary';
import { XmStore, XmStoreUtil } from 'services/store';
import { Util } from 'services/util';
import { CmsLevelMoveStart } from 'store/cms/models';
import { LevelMoveOrderReview } from 'store/level-move/models/order-review';
import { PlanSwitchOrderReview } from 'store/plan-eligibility/models/order-review';
@Component({
    selector: 'xm-order-summary',
    templateUrl: './order-summary.html',
    styleUrls: ['./order-summary.scss'],
    standalone: false
})
export class XmOrderSummaryComponent implements OnInit, OnDestroy {
    @Input() public cmsData: LevelMoveOrderReview | PlanSwitchOrderReview;
    public planIcon: MediaImageOptions;
    public isExpanded: boolean = true;

    private xmStore: XmStore;
    private subscriptions: Subscription[] = [];

    constructor(xmStore: XmStore) {
        Object.assign(this, { xmStore });
    }

    public ngOnInit(): void {
        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsLevelMoveStart>(CmsLevelMoveStart), (result: CmsLevelMoveStart) => {
            this.planIcon = {
                mobile: Cloudinary.generateMediaFromCms(result.unlimitedIcon)
            };
        }));
    }

    public badgeIcon(badge: string): MediaImageOptions {
        return {
            mobile: {
                base: badge,
                alt: 'Badge Icon'
            }
        };
    }

    public getDeviceImage(device: LevelMoveOrderDevice): MediaImageOptions {
        return {
            mobile: {
                base: device && device.image,
                useBoundingBox: true,
                trimTransparency: true
            }
        };
    }
    
    public ngOnDestroy(): void {
        Util.unsubscribeAll(this.subscriptions);
    }
}
